<template>
  <div class="card">
    <div class="card-header large">
      <img :src="getIcon('settings.svg')" alt="" />
      <p class="heading brand">
        {{ $t('BrandColor.filter_brand') }}
      </p>
      <!-- ponytail: updateHistory:false — smooth-scroll's own pushState desyncs the step/browser-history mixin (DEV-525) -->
      <a
        class="emat-btn to-results"
        href="#results"
        v-smooth-scroll="{ updateHistory: false }"
      >
        {{ $t('global.word.to_results') }}
      </a>
    </div>
    <div class="card-content">
      <transition-group name="fade" tag="div" class="brands">
        <BrandSelectionItem
          v-for="(brand, index) in brands"
          :key="brand.id + brand.name"
          :brand="brand"
          :is-first="index === 0"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import BrandSelectionItem from './BrandSelectionItem';

export default {
  name: 'BrandSelection',
  components: { BrandSelectionItem },
  props: {
    brands: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.to-results {
  font-size: 16px;
}

.heading.brand {
  display: flex !important;
  justify-content: space-between;
}
</style>
